import HeroComponent from "../../../ui/heroComponent";

const ContactHeroSection = () => {
  return (
    <HeroComponent subHeading="Contact us" heading1="We value your feedback" />
  );
};

export default ContactHeroSection;
